var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotificacionSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d444c;stroke:#3d444c;stroke-miterlimit:10;stroke-width:.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.15,31.6H2.16c-.97,0-1.76-.79-1.76-1.76,0-.52,.22-1,.62-1.34,1.85-1.57,2.91-3.84,2.91-6.26v-3.57c0-4.54,3.69-8.23,8.23-8.23s8.23,3.69,8.23,8.23v3.57c0,2.41,1.06,4.69,2.9,6.25,.4,.34,.63,.83,.63,1.35,0,.97-.79,1.76-1.76,1.76ZM12.16,11.62c-3.89,0-7.05,3.16-7.05,7.05v3.57c0,2.76-1.21,5.36-3.32,7.15-.14,.12-.21,.28-.21,.45,0,.32,.26,.59,.59,.59H22.15c.32,0,.59-.26,.59-.59,0-.17-.08-.34-.21-.45-2.11-1.79-3.32-4.39-3.32-7.15v-3.57c0-3.89-3.16-7.05-7.05-7.05h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificacionSmall);
export default __webpack_public_path__ + "static/media/icon_notificacion_small.a277b184200eaaba7fa09d8c428385f2.svg";
export { ForwardRef as ReactComponent };